import request from '@/utils/request'

// 查询支付渠道列表
export function listChannel(query) {
  return request({
    url: '/system/pay/channel/list',
    method: 'get',
    params: query
  })
}

// 查询支付渠道详细
export function getChannel(id) {
  console.log("id", id)
  return request({
    url: '/system/pay/channel/' + id,
    method: 'get'
  })
}

// 查询支付渠道详细
export function findChannel(merchantId, appId, payCode) {
  return request({
    url: `/system/pay/channel/getChannel/${merchantId}/${appId}/${payCode}`,
    method: 'get'
  })
}



// 新增支付渠道
export function addPayChannel(data) {
  return request({
    url: '/system/pay/channel/addPayChannel',
    method: 'post',
    data: data
  })
}

// 新增支付渠道
export function addChannel(data) {
  return request({
    url: '/system/pay/channel',
    method: 'post',
    data: data
  })
}

// 修改支付渠道(普通修改)
export function editPayChannel(data) {
  return request({
    url: '/system/pay/channel/editPayChannel',
    method: 'put',
    data: data
  })
}

// 修改支付渠道
export function updateChannel(data) {
  return request({
    url: '/system/pay/channel',
    method: 'put',
    data: data
  })
}

// 删除支付渠道
export function delChannel(id) {
  return request({
    url: '/system/pay/channel/' + id,
    method: 'delete'
  })
}
